export function removeSpinner(anchorElement: HTMLAnchorElement, addedElements: Node[]) {
    addedElements.forEach(element => {
        try {
            anchorElement.removeChild(element);
        } catch (Exception) {
            // In case user has removed the spinner
        }
    });

    anchorElement.setAttribute('contenteditable', 'true');
    anchorElement.style.pointerEvents = 'auto';
    anchorElement.removeEventListener('click', (event: MouseEvent) => {
        event.preventDefault();
    });
}
